export const TOGGLE_COLLAPSE_MENU = '@GeneralProvider/TOGGLE_COLLAPSE_MENU';

export const SET_POPUP = '@GeneralProvider/SET_POPUP';
export const SET_CHANGE_PASSWORD_MODAL = '@GeneralProvider/SET_CHANGE_PASSWORD_MODAL';
export const SET_CREATE_AGENT_MODAL = '@GeneralProvider/SET_CREATE_AGENT_MODAL';

export const SET_EDIT_PROFILE_MODAL = '@GeneralProvider/SET_EDIT_PROFILE_MODAL';
export const SET_STORE_DETAIL_MODAL = '@GeneralProvider/SET_STORE_DETAIL_MODAL';